import React, {Component} from 'react';
import axios from 'axios';

import {
	Form, Button, Row, Col, Alert
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import LayoutPrivate from '../../../components/Layout/Private';

import {extendToken, setTitle} from '../../../util/common';

class ImportCharity extends Component {
	state = {
		success: false,
		proceed: false,
		error: false,
		email: '',
		file: null,
		created: null
	};

	componentDidMount() {
		extendToken();

		const {charityActionId} = this.props.match.params;

		setTitle(['Zbiórki', `Zbiórka #${charityActionId}`, 'Importuj wpłaty']);
	}

	handleSubmit = (e) => {
		e.preventDefault();

		const {
			email, file, created, proceed
		} = this.state;
		if (proceed) return false;

		if (!file || email === '') {
			this.setState({
				error: true,
				proceed: false,
				success: false
			});

			return false;
		}

		const {charityActionId} = this.props.match.params;

		this.setState({
			error: false,
			proceed: true,
			success: false
		});

		const formData = new FormData();
		formData.append('charity_action_id', charityActionId);
		formData.append('email', email);
		formData.append('file', file);
		formData.append('created', created);

		const headers = {
			headers: {
				'content-type': 'multipart/form-data'
			}
		};

		axios.post(`${process.env.REACT_APP_API_URL}/charity/add/mbank`, formData, headers)
			.then((res) => {
				if (res.success) {
					this.setState({
						error: false,
						proceed: false,
						success: true
					});

					setTimeout(() => {
						window.location.replace(`/charity/${charityActionId}`);
					}, 2000);
				} else {
					this.setState({
						error: true,
						proceed: false,
						success: false
					});
				}
			})
			.catch(() => {
				this.setState({
					error: true,
					proceed: false,
					success: false
				});
			});

		return true;
	};

	handleChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value
		});
	};

	handleFileChange = (e) => {
		this.setState({
			[e.target.name]: e.target.files[0]
		});
	};

	render() {
		const {charityActionId} = this.props.match.params;

		const {success, proceed, error} = this.state;

		return (
			<LayoutPrivate>
				<Row>
					<Col md={{span: 6, offset: 3}}>
						<h2 style={{marginBottom: '2rem'}}>
							Nowa wpłata dla zbiórki #
							{charityActionId}
						</h2>
						{
							error && (
								<Alert variant="danger">
									Popraw dane w formularzu, gdyż wystąpił błąd.
								</Alert>
							)
						}
						{
							proceed && (
								<Alert variant="warning">
									Dodawanie wpłaty w toku...
								</Alert>
							)
						}
						{
							success && (
								<Alert variant="success">
									Wpłata utworzona, trwa przekierowanie...
								</Alert>
							)
						}
						<Form onSubmit={this.handleSubmit}>
							<Form.Group className="mb-3" controlId="email">
								<Form.Label>E-mail sponsora</Form.Label>
								<Form.Control name="email" type="email" placeholder="Wpisz e-mail sponsora" onChange={this.handleChange} />
							</Form.Group>

							<Form.Group className="mb-3" controlId="price">
								<Form.Label>Plik CSV mBank</Form.Label>
								<Form.Control name="file" type="file" onChange={this.handleFileChange} />
							</Form.Group>

							<Form.Group className="mb-3" controlId="created">
								<Form.Label>Data wpłaty (opcjonalnie)</Form.Label>
								<Form.Control name="created" type="date" placeholder="Wprowadź datę" onChange={this.handleChange} />
							</Form.Group>

							<Button variant="primary" type="submit">
								Zaimportuj nowe wpłaty
							</Button>
						</Form>
					</Col>
				</Row>
			</LayoutPrivate>
		);
	}
}

ImportCharity.propTypes = {
	match: PropTypes.object.isRequired
};

export default ImportCharity;
